"use strict";

(() => {
    const accordionElements = document.querySelectorAll('.bs-product-details__accordion__label');

    accordionElements.forEach((accordionElement) => {
        accordionElement.addEventListener('click', (e) => {
            e.currentTarget.parentElement.classList.toggle('active');
        });
    });
})();